export default function appendPercentSign(value) {
    return `${value}%`;
}
